import { ViewEncapsulation, Injectable, Component,
    OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ProductTypePipe } from "../../product-type.pipe";
import { NgbDateStruct, NgbCalendar, NgbDatepickerI18n, NgbDateParserFormatter, } from "@ng-bootstrap/ng-bootstrap";
import * as echarts from "echarts";
import * as _ from "lodash";
import * as moment from "moment";
moment.locale("zh-tw");

import { Domain as WebsideDomain } from "../../../../../lib/Domain/Webside";
import { Domain as ProductDomain } from "../../../../../lib/Domain/Product";
import { Domain } from "../../../../../lib/Domain";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../http.service";

const now = new Date();
const I18N_VALUES = {
    weekdays: ["日", "一", "二", "三", "四", "五", "六"],
    months: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
};

enum chartType {
    voltage,
    current,
    watt,
    pf,
    hz,
    kwh,
    var_a,
    va,
    angle,
    kvarh,
    kvah,
    demend
}

// 多語系參考https://ng-bootstrap.github.io/#/components/datepicker/examples
@Injectable()
export class IDatepickerZHI18n extends NgbDatepickerI18n {

    getWeekdayShortName(weekday: number) {
        return I18N_VALUES.weekdays[weekday - 1];
    }

    getMonthShortName(month: number) {
        return I18N_VALUES.months[month - 1];
    }

    getMonthFullName(month: number) {
        return this.getMonthShortName(month);
    }
}
// 參考https://ng-bootstrap.github.io/#/components/datepicker/api#NgbDateParserFormatter
export class IDatepickerZHFormater extends NgbDateParserFormatter {
    parse(value: string) {
        if (value != null) {
            value = value.replace("年", "|").replace("月", "|")
                .replace("日", "").replace("/", "").replace("-", "");
            const values = value.split("|");
            if (values.length >= 3) {
                return <NgbDateStruct>{
                    year: parseInt(values[0].trim(), 10),
                    month: parseInt(values[1].trim(), 10),
                    day: parseInt(values[2].trim(), 10),
                };
            }
        }
        return undefined;
    }

    format(date: NgbDateStruct) {
        if (date != null) {
            return `${date.year}年${date.month}月${date.day}日`;
        }
        return "";
    }
}


@Component({
    selector: "app-smart-cbdetail",
    templateUrl: "./smart-cbdetail.component.html",
    styleUrls: ["./smart-cbdetail.component.css"],
    providers: [
        { provide: NgbDatepickerI18n, useClass: IDatepickerZHI18n },
        { provide: NgbDateParserFormatter, useClass: IDatepickerZHFormater },
        NgbCarouselConfig,
    ]
})

export class SmartCbdetailComponent implements OnInit, OnChanges {
    @Input() source: WebsideDomain.ISmartPanelStatusCBResult = undefined;
    OnMessageOKCallback: (callback: () => void) => void;
    OnMessageCancelCallBack: (callback: () => void) => void;
    p: WebsideDomain.ISmartCBConfigProtection = undefined;
    history_chart: echarts.EChartOption;
    main_chart: echarts.EChartOption;
    main_chart_load = false;
    history_chart_load = false;
    datestamp = "";
    fulldatestamp = "";
    erro_message = "";
    main_erromessage = "";
    smartCBEventspage = 1;
    onselected = "month";
    IOver = "";
    VOver = "";
    alarmlimit = 0.9;
    public isAvailable = false;
    public enable = false;
    public dp_start: NgbDateStruct;
    public dp_end: NgbDateStruct;
    public smartCBEvents: WebsideDomain.ISmartCBEventResult[] = [];
    public CHARTTypes = [
        { k: chartType.voltage, v: "電壓 (V)" },
        { k: chartType.current, v: "電流 (A)" },
        { k: chartType.watt, v: "功率 (W)" },
        { k: chartType.pf, v: "功因" },
        { k: chartType.hz, v: "頻率" },
        { k: chartType.kwh, v: "耗用電量 (kWh)" },
        { k: chartType.var_a, v: "VAR" },
        { k: chartType.va, v: "VA" },
        { k: chartType.kvah, v: "kVAh" },
        { k: chartType.kvarh, v: "kVARh" },
        { k: chartType.demend, v: "需量 (kW)" },
        // { k: chartType.angle, v: "angle" },

    ];
    public ng_select_panel = this.CHARTTypes[5];
    public viewMode = "realtime"; 
    tot: WebsideDomain.ISmartPanelUsages = {
        usage: {
            day: 0,
            month: 0,
            week: 0,
            year: 0,
            monthprice: 0,
            monthCO2: 0,
        },
        lastusage: {
            day: 0,
            month: 0,
            week: 0,
            year: 0,
            monthprice: 0,
            monthCO2: 0,
        },
        dayIcon: "fa fa-minus",
        monthIcon: "fa fa-minus",
        weekIcon: "fa fa-minus",
        yearIcon: "fa fa-minus",
        monthpriceIcon: "fa fa-minus",
        monthCO2Icon: "fa fa-minus",
        taipowerPriceDesc: "",
    };
    public list_button: any[] = [{
        text: "今年",
        methed: () => {
            this.dp_start = { year: now.getFullYear(), month: 1, day: 1 };
            this.dp_end = { year: now.getFullYear(), month: 12, day: 31 };
            // this.OnRequest();
        }
    }, {
        text: "本月",
        methed: () => {
            this.dp_start = { year: now.getFullYear(), month: now.getMonth() + 1, day: 1 };
            let selectdate = moment(new Date(`${this.dp_start.year}/${this.dp_start.month}/01`));
            this.dp_start = {
                year: selectdate.toDate().getFullYear(),
                month: selectdate.toDate().getMonth() + 1,
                day: selectdate.toDate().getDate()
            };
            selectdate = selectdate.add(1, "month").subtract(1, "day");
            this.dp_end = {
                year: selectdate.toDate().getFullYear(),
                month: selectdate.toDate().getMonth() + 1,
                day: selectdate.toDate().getDate()
            };
            // this.OnRequest(this.type, this.uuids);
        }
    }, {
        text: "本週",
        methed: () => {
            let selectdate = moment();
            this.dp_end = {
                year: selectdate.toDate().getFullYear(),
                month: selectdate.toDate().getMonth() + 1,
                day: selectdate.toDate().getDate()
            };
            selectdate = selectdate.add(-7, "days");
            this.dp_start = {
                year: selectdate.toDate().getFullYear(),
                month: selectdate.toDate().getMonth() + 1,
                day: selectdate.toDate().getDate()
            };

            //  this.OnRequest(this.type, this.uuids);
        }
    }, {
        text: "今日",
        methed: () => {
            let selectdate = moment();
            this.dp_start = {
                year: selectdate.toDate().getFullYear(),
                month: selectdate.toDate().getMonth() + 1,
                day: selectdate.toDate().getDate()
            };
            selectdate = selectdate.add(1, "days");
            this.dp_end = {
                year: selectdate.toDate().getFullYear(),
                month: selectdate.toDate().getMonth() + 1,
                day: selectdate.toDate().getDate()
            };
            // this.OnRequest(this.type, this.uuids);
        }
    }];


    constructor(private httpService: HttpService, private modalService: NgbModal, config: NgbCarouselConfig) {
        // customize default values of carousels used by this component tree
        config.interval = 10000;

    }
    onalarm() {
        if (this.enable) {
            if (this.source.c && this.source.v) {
                if (this.source.c.protection.enable && 
                    (this.source.v.ia / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "alarm-blink";
                } else if (this.source.c.protection.enable &&
                    (this.source.v.ic / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "alarm-blink";
                } else if (this.source.c.protection.enable &&
                     (this.source.v.ib / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "alarm-blink";
                } else {
                    return "";
                }
            } else {
                return "";
            }
        } else {
            return "";
        }
    }
    onItr(td: string) {
        if (this.enable) {
            if (this.source.c && this.source.v) {
                if (td === "ia" && this.source.c.protection.enable &&
                 (this.source.v.ia / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "alarm-blink";
                }
                if (td === "ib" && this.source.c.protection.enable &&
                 (this.source.v.ib / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "alarm-blink";
                }
                if (td === "ic" && this.source.c.protection.enable &&
                 (this.source.v.ic / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "alarm-blink";
                }
                return "";
            } else {
                return "";
            }
        } else {
            return "";
        }
    }
    onClass() {
        if (this.enable) {
            if (this.source.c && this.source.v) {
                if (this.source.c.protection.enable &&
                     (this.source.v.ia / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "card mb-3 alarm-blink";
                } else if (this.source.c.protection.enable &&
                     (this.source.v.ib / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "card mb-3 alarm-blink";
                } else if (this.source.c.protection.enable &&
                     (this.source.v.ic / this.source.c.protection.current_max) >= this.alarmlimit) {
                    return "card mb-3 alarm-blink";
                } else {
                    return "card mb-3 ";
                }
            } else {
                return "card mb-3 ";
            }
        } else {
            return "card bg-light mb-3";
        }
        // return this.enable ? "card mb-3 " : "card bg-light mb-3";//alarm-blink
    }
    onbtnClass() {
        return this.enable ? "btn btn-primary" : "btn btn-light";
    }
    ngOnInit() {
        this.dp_start = {
            year: moment().toDate().getFullYear(),
            month: moment().toDate().getMonth() + 1,
            day: 1
        };
        this.dp_end = {
            year: moment().add(1, "days").toDate().getFullYear(),
            month: moment().add(1, "days").toDate().getMonth() + 1,
            day: moment().add(1, "days").toDate().getDate()
        };
    }
    private floats(num: number, fixed: number = 1): number {
        return parseFloat(num.toFixed(fixed));
    }
    async OnCreateNew(content: any) {
        this.protection_updated = false;
        this.modalService.open(content, { size: "lg" });
        // 取得loadprofile
        const thisyear = await this.httpService.smartPanelService.SmartCBUsages(this.source.c.uuid);
        if (thisyear) {
            // this.tot.usage = thisyear.usage;
            // this.tot.lastusage = thisyear.lastusage;
            this.tot = thisyear;
        }
        this.onChangeMainChart("month");
        // get events
        this.smartCBEvents = await this.httpService.smartPanelService.SmartCBEvents(this.source.c.uuid,//"2c40c27f-2b92-492d-b626-d56f6a7423cf",
            moment().add(-1, "months").toDate(),
            moment().add(1, "days").toDate());
        this.smartCBEvents = this.smartCBEvents.reverse();
        this.smartCBEventspage = 1;
    }
    async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        this.reload();
        this.IOver = "";
        if (this.enable) {
            if (this.source.c && this.source.v) {
                if (this.source.c.protection.enable &&
                     (this.source.v.ia / this.source.c.protection.current_max) >= this.alarmlimit) {
                    this.IOver = `A`;
                }
                if (this.source.c.protection.enable &&
                     (this.source.v.ib / this.source.c.protection.current_max) >= this.alarmlimit) {
                    this.IOver += `B`;
                }
                if (this.source.c.protection.enable &&
                     (this.source.v.ic / this.source.c.protection.current_max) >= this.alarmlimit) {
                    this.IOver += `C`;
                }
                if (this.IOver !== "") {
                    this.IOver = `${this.IOver}相電流接近保護上限 ${this.source.c.protection.current_max} A`;
                }
            }
        }
    }
    onChangeMainClass(n: string) {
        if (n === "A") {
            if (this.enable) {
                if (this.source.c && this.source.v) {
                    if (this.source.c.protection.enable &&
                         (this.source.v.ia / this.source.c.protection.current_max) >= this.alarmlimit) {
                        return (this.onselected === n) ? "active alarm-blink" : "alarm-blink";
                    } else if (this.source.c.protection.enable &&
                         (this.source.v.ib / this.source.c.protection.current_max) >= this.alarmlimit) {
                        return (this.onselected === n) ? "active alarm-blink" : "alarm-blink";
                    } else if (this.source.c.protection.enable &&
                         (this.source.v.ic / this.source.c.protection.current_max) >= this.alarmlimit) {
                        return (this.onselected === n) ? "active alarm-blink" : "alarm-blink";
                    } else {
                        return (this.onselected === n) ? "active" : "";
                    }
                } else {
                    return (this.onselected === n) ? "active" : "";
                }
            } else {
                return (this.onselected === n) ? "active" : "";
            }
        }
        return (this.onselected === n) ? "active" : "";
    }
    async onChangeMainChart(n: string) {
        this.onselected = n;
        this.main_erromessage = "";
        this.main_chart_load = true;
        let result: WebsideDomain.ISmartCBLoadProfileResult[] = [];
        switch (this.onselected) {
            case "V":
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment().add(-1, "days").toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) {
                    // 資料處理
                    result = _.filter(result, (v: WebsideDomain.ISmartCBLoadProfileResult) => {
                        return (moment().add(-1, "days") <= moment(v.date_time_string))
                    });
                }
                if (result.length > 0) {
                    let series: any[] = [];
                    let labels: string[] = [];
                    let legend: string[] = [];
                    let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("DD HH:mm") });
                    dayarray.push(moment(this.source.v.update_time_stamp).format("DD HH:mm"));
                    legend.push("A相電壓");
                    legend.push("B相電壓");
                    legend.push("C相電壓");
                    legend.push("平均電壓");
                    series.push({
                        name: "A相電壓",
                        type: "line",
                        // stack: "總度數",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.va) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相電壓",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.vb) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相電壓",
                        type: "line",
                        // stack: "總度數",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.vc) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "平均電壓",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.vavg) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series[0].data.push(this.floats(this.source.v.va));
                    series[1].data.push(this.floats(this.source.v.vb));
                    series[2].data.push(this.floats(this.source.v.vc));
                    series[3].data.push(this.floats(this.source.v.vavg));
                    this.main_chart = this.LINE_CBHISTORY("24小時內電壓資料", legend, dayarray, series, "(V)");
                } else {
                    this.main_erromessage = "無24小時內電壓資料可供檢視"
                }
                break;
            case "A":
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment().add(-1, "days").toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) {
                    // 資料處理
                    result = _.filter(result, (v: WebsideDomain.ISmartCBLoadProfileResult) => {
                        return (moment().add(-1, "days") <= moment(v.date_time_string))
                    });
                }
                if (result.length > 0) {

                    let series: any[] = [];
                    let labels: string[] = [];
                    let legend: string[] = [];
                    let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("DD HH:mm") });
                    dayarray.push(moment(this.source.v.update_time_stamp).format("DD HH:mm"));
                    legend.push("A相電流");
                    legend.push("B相電流");
                    legend.push("C相電流");
                    legend.push("in");
                    legend.push("總電流");
                    series.push({
                        name: "A相電流",
                        type: "line",
                        // stack: "總度數",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.ia) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相電流",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.ib) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相電流",
                        type: "line",
                        // stack: "總度數",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.ic) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "in",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.i_n) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "總電流",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.isum) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series[0].data.push(this.floats(this.source.v.ia));
                    series[1].data.push(this.floats(this.source.v.ib));
                    series[2].data.push(this.floats(this.source.v.ic));
                    series[2].data.push(this.floats(this.source.v.i_n));
                    series[3].data.push(this.floats(this.source.v.isum));
                    this.main_chart = this.LINE_CBHISTORY("24小時內電流資料", legend, dayarray, series, "(A)");
                } else {
                    this.main_erromessage = "無24小時內電流資料可供檢視"
                }
                break;
            case "W":
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment().add(-1, "days").toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) {
                    // 資料處理
                    result = _.filter(result, (v: WebsideDomain.ISmartCBLoadProfileResult) => {
                        return (moment().add(-1, "days") <= moment(v.date_time_string))
                    });
                }
                if (result.length > 0) {
                    let series: any[] = [];
                    let labels: string[] = [];
                    let legend: string[] = [];
                    let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("DD HH:mm") });
                    dayarray.push(moment(this.source.v.update_time_stamp).format("DD HH:mm"));
                    legend.push("A相功率");
                    legend.push("B相功率");
                    legend.push("C相功率");
                    legend.push("總功率");
                    series.push({
                        name: "A相功率",
                        type: "line",
                        // stack: "總度數",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.watt_a) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相功率",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.watt_b) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相功率",
                        type: "line",
                        // stack: "總度數",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.watt_c) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "總功率",
                        type: "line",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.watt_t) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series[0].data.push(this.floats(this.source.v.watt_a));
                    series[1].data.push(this.floats(this.source.v.watt_b));
                    series[2].data.push(this.floats(this.source.v.watt_c));
                    series[3].data.push(this.floats(this.source.v.watt_t));
                    this.main_chart = this.LINE_CBHISTORY("24小時內功率資料", legend, dayarray, series, "(W)");
                } else {
                    this.main_erromessage = "無24小時內功率資料可供檢視"
                }
                break;
            case "day":
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment(moment().format("YYYY-MM-DD")).toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) { result = this.demandTOKWH(result, "day"); }// 資料處理 
                if (result.length > 0) {
                    let series: any[] = [];
                    let labels: string[] = [];
                    let legend: string[] = [];
                    let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("HH時") });
                    legend.push("A相");
                    legend.push("B相");
                    legend.push("C相");
                    // legend.push("累積耗用電量");
                    series.push({
                        name: "A相",
                        type: "bar",
                        stack: "累積耗用電量",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.kwha) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相",
                        type: "bar",
                        stack: "累積耗用電量",
                        // areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.kwhb) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相",
                        type: "bar",
                        stack: "累積耗用電量",
                        // areaStyle: { normal: {} },
                        areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.kwhc) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    // series.push({
                    //     name: "累積耗用電量",
                    //     type:"bar",
                    //     // stack: "總度數",
                    //     // areaStyle: { normal: {} },
                    //     data: _.map(result, (v) => { return this.floats(v.kwht) }),
                    //     markPoint: {
                    //         data: [
                    //             { type: "max", name: "最大值" },
                    //             { type: "min", name: "最小值" }
                    //         ]
                    //     },
                    //     markLine: {
                    //         data: [
                    //             { type: "average", name: "平均值" }
                    //         ]
                    //     }
                    // });
                    this.main_chart = this.LINE_CBHISTORY("今日耗用電量", legend, dayarray, series, "kWh");
                    this.main_chart.dataZoom = undefined;
                } else {
                    this.main_erromessage = "無今日耗用電量資料可供檢視"
                }
                break;
            case "week":
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment(moment().subtract(moment().weekday(), "days").format("YYYY-MM-DD")).toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) { result = this.demandTOKWH(result, "week"); }// 資料處理 
                if (result.length > 0) {
                    let series: any[] = [];
                    let labels: string[] = [];
                    let legend: string[] = [];
                    let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("MM-DD dddd") });
                    // dayarray.push(moment(this.source.v.update_time_stamp).format("MM-DD HH:mm"));
                    legend.push("A相");
                    legend.push("B相");
                    legend.push("C相");
                    // legend.push("累積耗用電量");
                    series.push({
                        name: "A相",
                        type: "bar",
                        stack: "累積耗用電量",
                        // areaStyle: { normal: {} },
                        areaStyle: { normal: {} },
                        data: _.map(result, (v) => { return this.floats(v.kwha) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwhb) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwhc) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    // series.push({
                    //     name: "累積耗用電量",
                    //     type:"bar",
                    //     data: _.map(result, (v) => { return this.floats(v.kwht) }),
                    //     markPoint: {
                    //         data: [
                    //             { type: "max", name: "最大值" },
                    //             { type: "min", name: "最小值" }
                    //         ]
                    //     },
                    //     markLine: {
                    //         data: [
                    //             { type: "average", name: "平均值" }
                    //         ]
                    //     }
                    // });
                    this.main_chart = this.LINE_CBHISTORY("本週耗用電量", legend, dayarray, series, "kWh");
                    this.main_chart.dataZoom = undefined;
                } else {
                    this.main_erromessage = "無本週耗用電量資料可供檢視"
                }
                break;
            case "year":
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment(moment().format("YYYY-01-01")).toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) { result = this.demandTOKWH(result, "year"); }// 資料處理 
                if (result.length > 0) {
                    let series: any[] = [];
                    let labels: string[] = [];
                    let legend: string[] = [];
                    let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("MM月") });
                    // dayarray.push(moment(this.source.v.update_time_stamp).format("MM-DD HH:mm"));
                    legend.push("A相");
                    legend.push("B相");
                    legend.push("C相");
                    // legend.push("平均耗用電量");
                    series.push({
                        name: "A相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwha) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwhb) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwhc) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    // series.push({
                    //     name: "平均耗用電量",
                    //     type: "line",
                    //     areaStyle: { normal: {} },
                    //     data: _.map(result, (v) => { return this.floats(v.kwht) }),
                    //     markPoint: {
                    //         data: [
                    //             { type: "max", name: "最大值" },
                    //             { type: "min", name: "最小值" }
                    //         ]
                    //     },
                    //     markLine: {
                    //         data: [
                    //             { type: "average", name: "平均值" }
                    //         ]
                    //     }
                    // });
                    this.main_chart = this.LINE_CBHISTORY("今年耗用電量", legend, dayarray, series, "kWh");
                    this.main_chart.dataZoom = undefined;
                } else {
                    this.main_erromessage = "無今年耗用電量資料可供檢視"
                }
                break;
            default:
                // 取得本月圖表
                result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
                    moment(moment().format("YYYY-MM-01")).toDate(),
                    moment().add(1, "days").toDate());
                if (result.length > 0) { result = this.demandTOKWH(result, "month"); }// 資料處理
                if (result.length > 0) {
                    const series: any[] = [];
                    const labels: string[] = [];
                    const legend: string[] = [];
                    const dayarray: string[] = _.map(result, (v) => {
                        return moment(v.date_time_string).format("DD日"); });
                    // dayarray.push(moment(this.source.v.update_time_stamp).format("MM-DD HH:mm"));
                    legend.push("A相");
                    legend.push("B相");
                    legend.push("C相");
                    // legend.push("平均耗用電量");
                    series.push({
                        name: "A相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => {
                            return this.floats(v.kwha) ; }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "B相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwhb) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    series.push({
                        name: "C相",
                        type: "bar",
                        stack: "累積耗用電量",
                        data: _.map(result, (v) => { return this.floats(v.kwhc) }),
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" }
                            ]
                        },
                        markLine: {
                            data: [
                                { type: "average", name: "平均值" }
                            ]
                        }
                    });
                    // series.push({
                    //     name: "平均耗用電量",
                    //     type: "line",
                    //     areaStyle: { normal: {} },
                    //     data: _.map(result, (v) => { return this.floats(v.kwht) }),
                    //     markPoint: {
                    //         data: [
                    //             { type: "max", name: "最大值" },
                    //             { type: "min", name: "最小值" }
                    //         ]
                    //     },
                    //     markLine: {
                    //         data: [
                    //             { type: "average", name: "平均值" }
                    //         ]
                    //     }
                    // });
                    this.main_chart = this.LINE_CBHISTORY("本月耗用電量", legend, dayarray, series, "kWh");
                    this.main_chart.dataZoom = undefined;
                } else {
                    this.main_erromessage = "無本月耗用電量資料可供檢視"
                }
                break;
        }
        this.main_chart_load = false;
        return;
    }
    private async reload() {
        try {
            if (this.source.v) {
                this.enable = true;
                this.datestamp = moment(this.source.v.update_time_stamp).fromNow();
                this.fulldatestamp = moment(this.source.v.update_time_stamp).format("YYYY-MM-DD HH:mm:ss");
                this.isAvailable = moment().diff(moment(this.source.v.update_time_stamp), "minutes") < 10;
            } else {
                this.datestamp = "很久以前";
                this.fulldatestamp = "很久以前"
                this.isAvailable = false;
            }
            if (this.source.c) {
                this.enable = this.source.c.enable;
                this.p = {
                    enable: this.source.c.protection.enable,
                    voltage_max: this.source.c.protection.voltage_max,
                    voltage_mIn: this.source.c.protection.voltage_mIn,
                    current_max: this.source.c.protection.current_max,
                    peak_cycle: this.source.c.protection.peak_cycle,
                    sag_cycle: this.source.c.protection.sag_cycle,
                };
            }
        } catch (err) {

        }
    }
    async OnFormRequest(form: any) {
        this.erro_message = "";
        if (this.dp_start === undefined) {
            this.erro_message = "請選擇起始日期";
            setTimeout(() => { this.erro_message = ""; }, 5000);
            return;
        }
        if (this.dp_end === undefined) {
            this.erro_message = "請選擇起始日期";
            setTimeout(() => { this.erro_message = ""; }, 5000);
            return;
        }
        if (typeof (this.dp_start) === "string") {
            this.erro_message = "起始日期格式錯誤，日期格式必須為yyyy年mm月dd日或是yyyy-mm-dd";
            setTimeout(() => { this.erro_message = ""; }, 5000);
            return;
        }
        if (typeof (this.dp_end) === "string") {
            this.erro_message = "結束日期格式錯誤，日期格式必須為yyyy年mm月dd日或是yyyy-mm-dd";
            setTimeout(() => { this.erro_message = ""; }, 5000);
            return;
        }
        await this.OnRequest();
    }

    private LINE_CBHISTORY(title: string, legend: any, xAxisLabel: any, series: any, format: string) {
        return <echarts.EChartOption>{
            title: {
                text: title,
            },
            tooltip: {
                trigger: "axis",
                // formatter: "{a} <br/>{b}: {c}" + format,
                axisPointer: {
                    type: "cross",
                    label: {
                        backgroundColor: "#6a7985"
                    }
                }
            },
            legend: {
                data: legend,
            },
            toolbox: {
                feature: {
                    saveAsImage: {}
                }
            },
            calculable: true,
            dataZoom: [{
                show: true,
                realtime: true,
                y: 36,
                height: 20,
                start: 0,
                end: 100,
            }],
            grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true
            },
            xAxis: [
                {
                    type: "category",
                    boundaryGap: true,
                    data: xAxisLabel,
                    // interval : 1,
                    // axisTick: {
                    //     interval: 1,
                    // },
                }
            ],
            yAxis: [
                {
                    type: "value",
                    axisLabel: {
                        formatter: "{value} " + format
                    }
                }
            ],
            series: series
        }
    }
    private async setViewMode(fn: string, mainCache?: any) {
        this.viewMode = fn;
        if (mainCache === undefined) {
          mainCache = await this.httpService.smartPanelService
            .SmartCBLoadProfiles(this.source.c.uuid,
              new Date(this.dp_start.year, this.dp_start.month - 1, this.dp_start.day),
              new Date(this.dp_end.year, this.dp_end.month - 1, this.dp_end.day));
        }
        let dayarray: string[];
        const series: any[] = [];
        const labels: string[] = [];
        const legend: string[] = [];
        this.table = [];
        const result2 = this.demandTOKWH(mainCache, this.viewMode);
        switch (fn) {
          case "day":
            dayarray = _.map(result2, (v) => {
              return moment(v.date_time_string).format("YYYY-MM-DD HH時");
            });
            break;
          case "month":
            dayarray = _.map(result2, (v) => {
              return moment(v.date_time_string).format("YYYY-MM-DD");
            });
            break;
          case "year":
            dayarray = _.map(result2, (v) => {
              return moment(v.date_time_string).format("YYYY年MM月");
            });
            break;
          default:
            dayarray = _.map(result2, (v) => {
              return moment(v.date_time_string).format("YYYY-MM-DD HH:mm");
            });
            break;
        }
        this.tablerow = _.map(result2, (v) => {
          return moment(v.date_time_string).toDate();
        });
        legend.push("A相耗用電量");
        legend.push("B相耗用電量");
        legend.push("C相耗用電量");
        series.push({
          name: "A相耗用電量",
          type: fn === "realtime" ? "line" : "bar",
          stack: "累積耗用電量",
          areaStyle: { normal: {} },
          data: _.map(result2, (v) => {
            return this.floats(v.kwha);
          }),
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" }
            ]
          },
          markLine: {
            data: [
              { type: "average", name: "平均值" }
            ]
          }
        });
        series.push({
          name: "B相耗用電量",
          type: fn === "realtime" ? "line" : "bar",
          stack: "累積耗用電量",
          areaStyle: { normal: {} },
          data: _.map(result2, (v) => {
            return this.floats(v.kwhb);
          }),
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" }
            ]
          },
          markLine: {
            data: [
              { type: "average", name: "平均值" }
            ]
          }
        });
        series.push({
          name: "C相耗用電量",
          type: fn === "realtime" ? "line" : "bar",
          stack: "累積耗用電量",
          // stack: "總度數",
          areaStyle: { normal: {} },
          data: _.map(result2, (v) => {
            return this.floats(v.kwhc);
          }),
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" }
            ]
          },
          markLine: {
            data: [
              { type: "average", name: "平均值" }
            ]
          }
        });
        this.table.push({
          header: "A相耗用電量",
          value: _.map(result2, (v) => {
            return this.floats(v.kwha);
          }),
        });
        this.table.push({
          header: "B相耗用電量",
          value: _.map(result2, (v) => {
            return this.floats(v.kwhb);
          }),
        });
        this.table.push({
          header: "C相耗用電量",
          value: _.map(result2, (v) => {
            return this.floats(v.kwhc);
          }),
        });
        this.table.push({
          header: "累積耗用電量",
          value: _.map(result2, (v) => {
            return this.floats(v.kwht);
          }),
        });
        this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 耗用電量歷史資料`, legend, dayarray, series, "(kWh)");
      }
    /**查詢 */
    private async OnRequest() {
        if (this.ng_select_panel.k !== chartType.kwh) {
            this.viewMode = "realtime";
          }
        this.history_chart_load = true;
        const result = await this.httpService.smartPanelService.SmartCBLoadProfiles(this.source.c.uuid,
            new Date(this.dp_start.year, this.dp_start.month - 1, this.dp_start.day),
            new Date(this.dp_end.year, this.dp_end.month - 1, this.dp_end.day));
        this.history_chart_load = false;
        if (result.length === 0) {
            this.erro_message = "無資料可供顯示";
            this.history_chart = undefined;
            return;
        }
        let series: any[] = [];
        let legend: string[] = [];
        let dayarray: string[] = _.map(result, (v) => { return moment(v.date_time_string).format("YYYY-MM-DD HH:mm") })
        switch (this.ng_select_panel.k) {
            case chartType.voltage:
                legend.push("A相電壓");
                legend.push("B相電壓");
                legend.push("C相電壓");
                legend.push("平均電壓");
                series.push({
                    name: "A相電壓",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.va) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相電壓",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.vb) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相電壓",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.vc) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "平均電壓",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.vavg) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 電壓歷史資料`, legend, dayarray, series, "(V)");
                break;
            case chartType.current:
                legend.push("A相電流");
                legend.push("B相電流");
                legend.push("C相電流");
                legend.push("in");
                legend.push("總電流");
                series.push({
                    name: "A相電流",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.ia) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相電流",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.ib) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相電流",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.ic) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "in",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.i_n) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總電流",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.isum) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 電流歷史資料`, legend, dayarray, series, "(A)");
                break;
            case chartType.watt:
                legend.push("A相功率");
                legend.push("B相功率");
                legend.push("C相功率");
                legend.push("總功率");
                series.push({
                    name: "A相功率",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.watt_a) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相功率",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.watt_b) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相功率",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.watt_c) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總功率",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.watt_t) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 功率歷史資料`, legend, dayarray, series, "(W)");
                break;
            case chartType.kwh:
                 await this.setViewMode(this.viewMode, result);
                 break;
            case chartType.kvarh:
                legend.push("A相kVARh");
                legend.push("B相kVARh");
                legend.push("C相kVARh");
                legend.push("總kVARh");
                series.push({
                    name: "A相kVARh",
                    type: "line",
                    // stack: "總度數",
                    areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarha) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相kVARh",
                    type: "line",
                    areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarhb) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相kVARh",
                    type: "line",
                    // stack: "總度數",
                    areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarhc) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總kVARh",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarht) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} kVARh歷史資料`, legend, dayarray, series, "(kVARh)");
                break;

            case chartType.hz:
                legend.push("頻率");
                series.push({
                    name: "頻率",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.frequency, 2) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 頻率歷史資料`, legend, dayarray, series, "(Hz)");
                break;
            case chartType.demend:
                legend.push("需量");
                series.push({
                    name: "需量",
                    type: "line",
                    // stack: "總度數",
                    areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.demand) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 需量歷史資料`, legend, dayarray, series, "kW");
                break;

            case chartType.pf:
                legend.push("A相功因");
                legend.push("B相功因");
                legend.push("C相功因");
                legend.push("總功因");
                series.push({
                    name: "A相功因",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.pf_a, 3) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相功因",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.pf_b, 3) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相功因",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.pf_c, 3) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總功因",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.pf_t, 3) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} 功率因數歷史資料`, legend, dayarray, series, "");
                break;

            case chartType.va:
                legend.push("A相VA");
                legend.push("B相VA");
                legend.push("C相VA");
                legend.push("總VA");
                series.push({
                    name: "A相VA",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.va_a) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相VA",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.va_b) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相VA",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.va_c) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總VA",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.va_t) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} VA歷史資料`, legend, dayarray, series, "(VA)");
                break;
            case chartType.kvah:
                legend.push("A相kVAh");
                legend.push("B相kVAh");
                legend.push("C相kVAh");
                legend.push("總kVAh");
                series.push({
                    name: "A相kVAh",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvaha) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相kVAh",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvahb) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相kVAh",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvahc) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總kVAh",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvaht) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} VA歷史資料`, legend, dayarray, series, "(VA)");
                break;
            case chartType.var_a:
                legend.push("A相VAR");
                legend.push("B相VAR");
                legend.push("C相VAR");
                legend.push("總VAR");
                series.push({
                    name: "A相VAR",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.var_a) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相VAR",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.var_b) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相VAR",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.var_c) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總VAR",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.var_t) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} VAR歷史資料`, legend, dayarray, series, "(VAR)");
                break;

            case chartType.kvarh:
                legend.push("A相kVARh");
                legend.push("B相kVARh");
                legend.push("C相kVARh");
                legend.push("總kVARh");
                series.push({
                    name: "A相kVARh",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarha) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "B相kVARh",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarhb) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "C相kVARh",
                    type: "line",
                    // stack: "總度數",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarhc) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                series.push({
                    name: "總kVARh",
                    type: "line",
                    // areaStyle: { normal: {} },
                    data: _.map(result, (v) => { return this.floats(v.kvarht) }),
                    markPoint: {
                        data: [
                            { type: "max", name: "最大值" },
                            { type: "min", name: "最小值" }
                        ]
                    },
                    markLine: {
                        data: [
                            { type: "average", name: "平均值" }
                        ]
                    }
                });
                this.history_chart = this.LINE_CBHISTORY(`${this.source.c.meta_data.name} kVARh歷史資料`, legend, dayarray, series, "(kVARh)");
                break;
            // 缺 angle
            default:
                break;


        }
    }
    ansiMeterForm(wiring: number): string {
        /**
         * 00 4-wire wye
         * 01 3-wire delta
         * 10 4-wire wye
         * 11 4-wire delta
         */
        /**
         * ANSI Meter Form
            9S/16S
            5S/13S
            6S/14S
            8S/15S
         */
        // Wiring: 0b00 | 0b01 | 0b10 | 0b11;
        switch (wiring) {
            case 0b00:
                return "9S/16S";
            case 0b01:
                return "5S/13S";
            case 0b10:
                return "6S/14S";
            case 0b11:
                return "8S/15S";
        }
    }
    BuadRate(buad: number) {
        /**
        * 1:9600, 2:19200, 3:38400, 4:115200
        */
        switch (buad) {
            case 1:
                return "9600";
            case 2:
                return "19200";
            case 3:
                return "38400";
            case 4:
                return "115200";
        }
    }
    Parity(buad: number) {
        /**
         * 0:none, 1:odd, 2:even
         */
        switch (buad) {
            case 0:
                return "NONE";
            case 1:
                return "ODD";
            case 2:
                return "EVEN";
        }
    }
    smartCB_relay_issending = false;
    onRelaycfm(content) {
        this.protection_updated = false;
        this.modalService.open(content);
    }
    public async onRelay(d?: () => void) {
        this.smartCB_relay_issending = true;
        await this.httpService.smartPanelService.SmartCBRelayControl(this.source.c.server_uuid, this.source.c.uuid, !this.source.o.relay_status);
        setTimeout(async () => {
            const nowstate = !this.source.o.relay_status;
            const result = await this.httpService.smartPanelService.CBstatus(this.source.c.server_uuid, this.source.c.uuid);
            if (result) {
                if (result.o.relay_status !== nowstate) {
                    result.o.relay_status = nowstate;
                }
                this.source = result;
            }
            this.smartCB_relay_issending = false;
        }, 5000);
        if (d !== undefined) {
            d();
        }
    }
    protection_updating = false;
    protection_updating_confirm = false;
    protection_updated = false;
    public async onProtectionSet() {
        this.protection_updating = true;
        await this.httpService.smartPanelService.SmartCBProtectionSet(this.source.c.server_uuid, this.source.c.uuid, this.p);
        if (this.source.c) {
            this.source.c.protection.enable = this.p.enable;
            this.source.c.protection.current_max = this.p.current_max;
            this.source.c.protection.peak_cycle = this.p.peak_cycle;
            this.source.c.protection.voltage_max = this.p.voltage_max;
            this.source.c.protection.voltage_mIn = this.p.voltage_mIn;
            this.source.c.protection.sag_cycle = this.p.sag_cycle;
        }
        setTimeout(async () => {
            const result = await this.httpService.smartPanelService.CBstatus(this.source.c.server_uuid, this.source.c.uuid);
            if (result) {
                this.source = result;
            }
            this.protection_updating = false;
            this.protection_updating_confirm = false;
            this.protection_updated = true;
        }, 5000);
    }
    // #region "events"
    EventLoop(value: number) {
        switch (value) {
            case 0: return "系統";
            case 1: return "A相";
            case 2: return "B相";
            case 3: return "C相";
            default: return value.toString();
        }
    }
    EvnetType(value: number) {
        switch (value) {
            case 0: return "未使用";
            case 1: return "過電壓警報";
            case 2: return "過電流警報";
            case 3: return "SAG";
            case 257: return "系統啟動";
            case 258: return "保護功能啟動造成開關跳脫";
            case 259: return "從SmartCB開啟開關";
            case 260: return "從SmartCB關閉開關";
            case 261: return "從遠端開啟開關";
            case 262: return "從遠端關閉開關";
            default: return value.toString();
        }
    }
    EventLevel(value: number) {
        switch (value) {
            case 0: return "提醒";
            case 1: return "警告";
            case 2: return "錯誤";
            case 3: return "致命";
            default: return value.toString();
        }
    }
    EventString(event: WebsideDomain.ISmartCBEventResult) {
        // const errorMessage = event.iscurrent ? "" : `[${event.errormessage}]`;
        const date = moment(event.event_date_time).format("YYYY-MM-DD HH:mm:ss");
        const alarm = event.info.alarm === 1 ? "[Alarm]" : "[Release/not alarm]";
        return `${this.EvnetType(event.info.etype)}`;
        // return `${errorMessage}${alarm}[${EventLevel(event.info.ELeve)}][${date}][${EvnetType(event.info.EType)}][${EventLoop(event.info.ELoop)}]`;
    }
    onAlarmClass(event: WebsideDomain.ISmartCBEventResult) {
        switch (event.info.eleve) {
            case 0: return "table-info";
            case 1: return "table-warning";
            case 2: return "table-danger";
            case 3: return "table-danger";
            default: return "";
        }
    }
    // #endregion
    demandTOKWH(data: WebsideDomain.ISmartCBLoadProfileResult[], parm: string): WebsideDomain.ISmartCBLoadProfileResult[] {
        // data.push(this.source.v! as WebsideDomain.ISmartCBLoadProfileResult);
        // console.log(this.source.v!);
        const now = this.newEmptyLoadProfile();
        now.kwht = this.source.v!.kwht;
        now.kwha = this.source.v!.kwha;
        now.kwhb = this.source.v!.kwhb;
        now.kwhc = this.source.v!.kwhc;
        now.date_time_string = this.source.v!.update_time_stamp;
        switch (parm) {
            case "day":
                // by 24 hours
                data = _.chain(data).groupBy(v => {
                    return moment(v.date_time_string).format("YYYY-MM-DD HH:00:00");
                })
                    .map((v, i) => {
                        v[v.length - 1].date_time_string = moment(i).toDate();
                        return v[v.length - 1];
                    }).value();
                for (let i = data.length-1; i >0; i--) {
                    data[i].kwht = data[i].kwht - data[i - 1].kwht;
                    data[i].kwha = data[i].kwha - data[i - 1].kwha;
                    data[i].kwhb = data[i].kwhb - data[i - 1].kwhb;
                    data[i].kwhc = data[i].kwhc - data[i - 1].kwhc;
                }
                // 補足前面的
                for (let i = 0; i < 24; i++) {
                    if (_.find(data, (v) => { return moment(v.date_time_string).hours() === i }) === undefined) {
                        const fill = this.newEmptyLoadProfile();
                        if (i < 10) {
                            fill.date_time_string = moment(moment(data[data.length - 1].date_time_string).format(`YYYY-MM-DD 0${i}:00:00`)).toDate();
                        } else {
                            fill.date_time_string = moment(moment(data[data.length - 1].date_time_string).format(`YYYY-MM-DD ${i}:00:00`)).toDate();
                        }
                        data.push(fill);
                    }
                }
                data = _.orderBy(data, "date_time_string");
                break;
            case "month":
                // by 24 hours
                data = _.chain(data).groupBy(v => {
                    return moment(v.date_time_string).format("YYYY-MM-DD")
                })
                    .map((v, i) => {
                        v = _.sortBy(v, "date_time_string");
                        v[v.length - 1].date_time_string = moment(i).toDate();
                        return v[v.length - 1];
                    }).value();
                for (let i = data.length - 1; i > 0; i--) {
                     data[i].kwht = data[i].kwht - data[i - 1].kwht;
                     data[i].kwha = data[i].kwha - data[i - 1].kwha;
                     data[i].kwhb = data[i].kwhb - data[i - 1].kwhb;
                     data[i].kwhc = data[i].kwhc - data[i - 1].kwhc;
                }
                // 補足前面的
                for (let i = 1; i <= moment().daysInMonth(); i++) {
                    if (_.find(data, (v) => {
                        return moment(v.date_time_string).date() === (i);
                    }) === undefined) {
                        if (i < 10) {
                            const fill = this.newEmptyLoadProfile();
                            fill.date_time_string = moment(moment(data[data.length - 1].date_time_string).format(`YYYY-MM-0${i}`)).toDate();
                            data.push(fill);
                        } else {
                            const fill = this.newEmptyLoadProfile();
                            fill.date_time_string = moment(moment(data[data.length - 1].date_time_string).format(`YYYY-MM-${i}`)).toDate();
                            data.push(fill);
                        }
                    }
                }
                data = _.orderBy(data, "date_time_string");
                break;
            case "week":
                // by 24 hours
                data = _.chain(data).groupBy(v => {
                    return moment(v.date_time_string).format("YYYY-MM-DD")
                })
                    .map((v, i) => {
                        v[v.length - 1].date_time_string = moment(i).toDate();
                        return v[v.length - 1];
                    }).value();
                for (let i = data.length-1; i >0; i--) {
                    data[i].kwht = data[i].kwht - data[i - 1].kwht;
                    data[i].kwha = data[i].kwha - data[i - 1].kwha;
                    data[i].kwhb = data[i].kwhb - data[i - 1].kwhb;
                    data[i].kwhc = data[i].kwhc - data[i - 1].kwhc;
                }
                let st = moment(moment().subtract(moment().weekday(), "days").format("YYYY-MM-DD"));
                let et = moment(moment().add(6, "days").format("YYYY-MM-DD"));
                let arrays = [];
                while (st < et) {
                    arrays.push(st.format("YYYY-MM-DD"));
                    st = st.add(1, "days")
                }
                // 補足前面的
                for (let item of arrays) {
                    if (_.find(data, (v) => { return moment(v.date_time_string).format("YYYY-MM-DD") === item }) === undefined) {
                        const fill = this.newEmptyLoadProfile();
                        fill.date_time_string = moment(item).toDate();
                        data.push(fill);
                    }
                }
                data = _.orderBy(data, "date_time_string");

                break;
            case "year":
                // by 24 hours
                data = _.chain(data).groupBy(v => {
                    return moment(v.date_time_string).format("YYYY-MM")
                })
                    .map((v, i) => {
                        v[v.length - 1].date_time_string = moment(i).toDate();
                        return v[v.length - 1];
                    }).value();
                for (let i = data.length-1; i >0; i--) {
                    data[i].kwht = data[i].kwht - data[i - 1].kwht;
                    data[i].kwha = data[i].kwha - data[i - 1].kwha;
                    data[i].kwhb = data[i].kwhb - data[i - 1].kwhb;
                    data[i].kwhc = data[i].kwhc - data[i - 1].kwhc;
                }
                // 補足前面的
                for (let i = 1; i <= 12; i++) {
                    if (_.find(data, (v) => { return moment(v.date_time_string).month() === i }) === undefined) {
                        if (i < 10) {
                            const fill = this.newEmptyLoadProfile();
                            fill.date_time_string = moment(moment(data[data.length - 1].date_time_string).format(`YYYY-0${i}-01`)).toDate();
                            data.push(fill);
                        } else {
                            const fill = this.newEmptyLoadProfile();
                            fill.date_time_string = moment(moment(data[data.length - 1].date_time_string).format(`YYYY-${i}-01`)).toDate();
                            data.push(fill);
                        }

                    }
                }
                data = _.orderBy(data, "date_time_string");
                break;
            case "realtime":
                break;
        }
        return data;
    }

    newEmptyLoadProfile(): WebsideDomain.ISmartCBLoadProfileResult {
        return {
            server_uuid: "",
            uuid: "",
            date_time_string: new Date(),
            /**
             * CQL 關鍵字 index
             */
            record_index: 0,

            va: 0,
            vb: 0,
            vc: 0,
            vavg: 0,

            ia: 0,
            ib: 0,
            ic: 0,
            /**
             * CQL 關鍵字 in
             */
            i_n: 0,
            isum: 0,

            watt_a: 0,
            watt_b: 0,
            watt_c: 0,
            watt_t: 0,

            var_a: 0,
            var_b: 0,
            var_c: 0,
            var_t: 0,

            va_a: 0,
            va_b: 0,
            va_c: 0,
            va_t: 0,

            pf_a: 0,
            pf_b: 0,
            pf_c: 0,
            pf_t: 0,

            angle_va: 0,
            angle_vb: 0,
            angle_vc: 0,

            angle_ia: 0,
            angle_ib: 0,
            angle_ic: 0,

            frequency: 0,

            vab: 0,
            vbc: 0,
            vca: 0,
            vii_avg: 0,

            kwht: 0,
            kwha: 0,
            kwhb: 0,
            kwhc: 0,

            kvarht: 0,
            kvarha: 0,
            kvarhb: 0,
            kvarhc: 0,

            kvaht: 0,
            kvaha: 0,
            kvahb: 0,
            kvahc: 0,

            demand: 0,

            prev_demand: 0,
            prev_demand2: 0,
            prev_demand3: 0,
            maxdemand_currnetmonth: 0,
            maxdemand_lastmonth: 0,
            remain_time: 0,

            kwht_inter: 0,
            kwha_inter: 0,
            kwhb_inter: 0,
            kwhc_inter: 0,

            kvarht_inter: 0,
            kvarha_inter: 0,
            kvarhb_inter: 0,
            kvarhc_inter: 0,

            kvaht_inter: 0,
            kvaha_inter: 0,
            kvahb_inter: 0,
            kvahc_inter: 0,
        }
    }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/component/smart-cbdetail/smart-cbdetail.component.ts